import * as React from 'react';

interface IProps {
  style?: React.CSSProperties;
  children: JSX.Element | Array<JSX.Element | string | number>;
  onSubmit?: (e: React.FormEvent<HTMLFormElement>) => void;
}
function Form(props: IProps) {
  return (
    <form noValidate={true} onSubmit={props.onSubmit} style={props.style}>
      {props.children}
    </form>
  );
}

export default Form;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/FormStateFields/Form.tsx